import React from "react";
import { Link as MuiLink, styled, TableCell, TableRow } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

const StyledTableRow = styled(TableRow)`
  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }
`;

const SearchTableRow = ({
  user,
}) => {
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`../users/${user.userEntityId}`);
  };

  return (
    <StyledTableRow>
      <TableCell
        component="th"
        scope="row"
        onClick={handleRowClick}
      >
        {user.lastName}
      </TableCell>
      <TableCell
        align="right"
        onClick={handleRowClick}
      >{user.firstName}
      </TableCell>
      <TableCell align="right">
        <Link to={`../emails/${user.userEmailEntityId}`}>
          <MuiLink component="span">
            {user.email}
          </MuiLink>
        </Link>
      </TableCell>
    </StyledTableRow>
  );
};

export default SearchTableRow;